import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/Button';

/**
 * The catch-all. Neither <Routes> block had one, so a mistyped URL, a logged-out
 * deep link, a lapsed Slack OAuth return and an invite link opened while already
 * signed in all rendered a completely blank page.
 */
export default function NotFound() {
  const location = useLocation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-surface-2">
        <i className="fas fa-compass text-title text-ink-500" aria-hidden="true" />
      </div>
      <h1 className="text-heading-sm text-ink-900">This page doesn&rsquo;t exist</h1>
      <p className="mt-2 max-w-md text-body text-ink-700">
        We couldn&rsquo;t find anything at{' '}
        <code className="rounded bg-surface-2 px-1.5 py-0.5 font-mono text-label text-ink-700">
          {location.pathname}
        </code>
        . It may have moved, or the link may be out of date.
      </p>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
        <Button as={Link} href="/" variant="primary">Go to Overview</Button>
        <Button as={Link} href="/calls" variant="secondary">Browse calls</Button>
      </div>
    </div>
  );
}
